export default __webpack_public_path__ + "static/media/mk-group-logo-text.84fd7fe5.svg";